import { put, call, takeEvery } from 'redux-saga/effects';

import { toggleModal } from 'altus-modal';
import { callAsync } from 'app/sagas/helperSagas';
import { addNotification } from 'altus-redux-middlewares';

import {
  ACTIONS,
  MODAL,
} from 'features/projects/mobilisation/projectMobilisation.constants';
import projectMobilisationService from 'features/projects/mobilisation/projectMobilisation.service';
import {
  receiveProjectMobilisationTasks,
  receiveStringTestReportEvent,
  receiveStringTestReportsForTask,
  receivestringtesttoolstringitems,
} from 'features/projects/mobilisation/projectMobilisation.actions';
import equipmentService from 'features/equipment/equipment.service';
import { EMPTY_STRING, NOTIFICATION_VARIANTS } from 'app/app.constants';
import { requestToolstringForTaskAsync } from '../tasks/task/toolstring/toolstring.sagas';

export function* requestMobilisationTasks(action) {
  const { projectId } = action;

  const projectMobilisationTasks = yield call(
    projectMobilisationService.getProjectMobilisationTasks,
    projectId,
  );

  yield call(
    projectMobilisationService.getProjectMobilisationToolstrings,
    projectId,
  );

  yield put(receiveProjectMobilisationTasks(projectMobilisationTasks));
}

export function* createStringTestReport(action) {
  const { taskId, stringTestReport, toggleModal } = action;

  const { toolstringId } = stringTestReport;

  const asset = {
    toolstringId,
    taskId,
    ...stringTestReport,
  };
  const stringTest = yield call(
    equipmentService.createStringTestAssetHistory,
    asset,
  );

  const stringTestReports = yield call(
    equipmentService.getStringVerificationsForToolstring,
    taskId,
    toolstringId,
    true,
    stringTest?.stringTestId,
  );

  yield put(receiveStringTestReportsForTask(stringTestReports));

  if (toggleModal) {
    yield put(toggleModal({ modalId: MODAL.STRING_TEST_REPORT_EVENT }));
  }
}

export function* requestStringTestReportsForTask(action) {
  const { taskId, toolstringId, stringTestId = null } = action;

  const stringTestReports = yield call(
    equipmentService.getStringVerificationsForToolstring,
    taskId,
    toolstringId,
    true,
    stringTestId,
  );
  yield put(receiveStringTestReportsForTask(stringTestReports));
}

export function* requestStringTestReportEventById(action) {
  const { projectId, taskId, stringTestReportEventId } = action;

  const event = yield call(
    projectMobilisationService.getStringTestReportEventById,
    projectId,
    taskId,
    stringTestReportEventId,
  );

  yield put(receiveStringTestReportEvent(event));
}

export function* createSecondaryStringTestReport(action) {
  const { projectId, taskId, toolstringId } = action;

  yield call(
    projectMobilisationService.createSecondaryStringTestReport,
    projectId,
    taskId,
    toolstringId,
  );

  const stringTestReports = yield call(
    projectMobilisationService.getStringTestReportsForTask,
    projectId,
    taskId,
  );

  yield put(receiveStringTestReportsForTask(stringTestReports));
}

export function* finishStringTestReport(action) {
  const {
    updateDraftReport,
    taskId,
    toolstringId,
    stringTestId = null,
  } = action;

  yield call(equipmentService.updateStringTestDraft, updateDraftReport);

  const stringTestReports = yield call(
    equipmentService.getStringVerificationsForToolstring,
    taskId,
    toolstringId,
    true,
    stringTestId,
  );

  yield put(receiveStringTestReportsForTask(stringTestReports));

  yield put(toggleModal({ modalId: MODAL.STRING_TEST_REPORT_EVENT }));
}

export function* updatestringtesttoolstringitem(action) {
  const { taskId, toolstringId, projectId, asset,stringTestId=null } = action;

  const assetDto = {
    toolstringItemId: asset.toolstringItemId,
    toolAssemblyId: asset.toolAssemblyId,
    toolAssemblyToolId: asset.toolAssemblyToolId,
    serialNumber: asset.serialNo === EMPTY_STRING ? null : asset.serialNo,
  };
  yield call(
    equipmentService.createstringtesttoolstringitem,
    taskId,
    toolstringId,
    assetDto,
  );
  yield call(requestToolstringForTaskAsync, {
    projectId,
    taskId,
    toolstringId,
    isMobilise: true,
    stringTestId,
  });

  yield call(getstringtesttoolstringitemsForToolstring, {
    taskId,
    toolstringId,
  });
}

export function* getstringtesttoolstringitemsForToolstring(action) {
  const { taskId, toolstringId } = action;

  const stringtesttoolstringitems = yield call(
    equipmentService.getstringtesttoolstringitemsForToolstring,
    taskId,
    toolstringId,
  );
  yield put(receivestringtesttoolstringitems(stringtesttoolstringitems));
}
export function* getstringtesttoolstringitemsForStringTestId(action) {
  const { stringTestId } = action;

  const stringtesttoolstringitems = yield call(
    equipmentService.getstringtesttoolstringitemsForStringTestId,
    stringTestId,
  );

  yield put(receivestringtesttoolstringitems(stringtesttoolstringitems));
}
export function* validatestringtesttoolstringitemsSerials(action) {
  const { stringtesttoolstringitemIds } = action;

  const dto = {
    stringtesttoolstringitemIds: stringtesttoolstringitemIds,
  };

  try {
    yield call(equipmentService.validatestringtesttoolstringitemSerial, dto);
    yield put(toggleModal({ modalId: MODAL.STRING_TEST_REPORT_EVENT }));
  } catch (error) {
    yield put(
      addNotification({
        message: 'Duplicate serial numbers found',
        duration: 5000,
        variant: NOTIFICATION_VARIANTS.ERROR,
      }),
    );
  }
}

export default function* root() {
  yield takeEvery(
    ACTIONS.VALIDATE_STRING_TEST_TOOL_STRING_ITEMS_SERIALS,
    callAsync,
    validatestringtesttoolstringitemsSerials,
  );

  yield takeEvery(
    ACTIONS.REQUEST_GET_STRING_TEST_TOOL_STRING_ITEMS,
    callAsync,
    getstringtesttoolstringitemsForToolstring,
  );

  yield takeEvery(
    ACTIONS.REQUEST_UPDATE_STRING_TEST_TOOL_STRING_ITEM,
    callAsync,
    updatestringtesttoolstringitem,
  );

  yield takeEvery(
    ACTIONS.REQUEST_PROJECT_MOBILISATION_TASKS,
    callAsync,
    requestMobilisationTasks,
  );

  yield takeEvery(
    ACTIONS.CREATE_STRING_TEST_REPORT,
    callAsync,
    createStringTestReport,
  );

  yield takeEvery(
    ACTIONS.REQUEST_STRING_TEST_REPORTS_FOR_TASK,
    callAsync,
    requestStringTestReportsForTask,
  );

  yield takeEvery(
    ACTIONS.REQUEST_STRING_TEST_REPORT_EVENT,
    callAsync,
    requestStringTestReportEventById,
  );

  yield takeEvery(
    ACTIONS.REQUEST_CREATE_SECONDARY_TEST_REPORT,
    callAsync,
    createSecondaryStringTestReport,
  );

  yield takeEvery(
    ACTIONS.REQUEST_FINISH_STRING_TEST_REPORT,
    callAsync,
    finishStringTestReport,
  );
}
